<div class="form-field">
  <span class="form-field-label">実施区分</span>
  <mat-radio-group
    aria-label="選択して下さい"
    [formControl]="form"
    class="container"
    (change)="onChange()"
  >
    <mat-radio-button
      *ngFor="let option of options"
      [value]="option"
      disableRipple
      class="item"
    >
      {{ option }}
    </mat-radio-button>
  </mat-radio-group>
</div>
